import * as types from './mutation-types'

const mutations = {
  [types.xbLogin](state, value) {
    state.xbToken = value
  },
  [types.xbUserInfo](state, info) {
    state.xbUserInfo = info
  },
  [types.xbLoginStatus](state, bool) {
    state.xbLoginStatus = bool
  },
  [types.dbLogin](state, value) {
    state.dbToken = value
  },
  [types.dbUserInfo](state, info) {
    state.dbUserInfo = info
  },
  [types.dbLoginStatus](state, bool) {
    state.dbLoginStatus = bool
  }
}

export default mutations
